import React from 'react'

const apps = {};
apps['Sydney'] = {
  appName:'Sydney Health',
  ios: 'https://apps.apple.com/app/id1463423283',
  android: 'https://play.google.com/store/apps/details?id=com.anthem.sydney'
};
apps['Engage Wellbeing'] = {
  appName:'Engage Wellbeing',
  ios: 'https://itunes.apple.com/us/app/engage-wellbeing/id1250194316?mt=8',
  android:
    'https://play.google.com/store/apps/details?id=com.anthemengage.mobile'
};

apps['Engage'] = {
  appName:'Engage Wellbeing',
  ios: 'https://itunes.apple.com/us/app/engage-wellbeing/id1250194316?mt=8',
  android:
    'https://play.google.com/store/apps/details?id=com.anthemengage.mobile'
};

export default state => {
  if(['Engage','Engage Wellbeing','Sydney'].indexOf(state.appType)!=-1)
  {
    state.mobileAppInfo = apps[state.appType];
  }
  else
  {
    state.mobileAppInfo = apps['Sydney'];
    state.mobileAppInfo.appName=state.appType?<span dangerouslySetInnerHTML={{__html:state.appType}}></span>:'Sydney Health';
  }
 
};
